export default {
    multiple_myeloma_line_of_treatment1: 'line of treatment 1',
    multiple_myeloma_line_of_treatment2: 'line of treatment 2',
    multiple_myeloma_line_of_treatment3: 'line of treatment 3',
    multiple_myeloma_line_of_treatment4: 'line of treatment 4',
    multiple_myeloma_line_of_treatment5: 'line of treatment 5',
};
